import React from 'react';
import PropTypes from 'prop-types';
import './TableCell.scss';

const TableCell = ({
  content,
  header,
  width,
  classes,
}) => {
  const cellClasses = ['table-cell', 'border-top'];
  if (header) cellClasses.push('table-header');
  return (
    <div className={[...cellClasses, ...[width], ...classes].join(' ').trim()}>
      {typeof content === 'function' ? content() : content }
    </div>
  );
};

TableCell.defaultProps = {
  content: '',
  header: false,
  classes: [''],
  width: '',
};

TableCell.propTypes = {
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]),
  header: PropTypes.bool,
  classes: PropTypes.arrayOf(PropTypes.string),
  width: PropTypes.string,
};

export default TableCell;



// WEBPACK FOOTER //
// ./src/components/Table/TableCell/TableCell.jsx